<template>
    <div style="height: 100%;">
        <div 
            class="menu_0" 
            v-loading="isLoading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <ul class="menu_left">
                <li :class="{ active: activeIndex2 == 0 }" @click="() => { myModelList = []; searchContent = ''; activeIndex2 = 0; firstCategory = false; pageNo = 1; loadMyModels(); }"> <i class="iconfont iconfenlei-wode"></i> <span>我的</span> </li>
                <li :class="{ active: activeIndex2 == 1 && firstCategory === '' }" @click="() => { searchContent = ''; activeIndex2 = 1; changeFirstCategory(''); }"> <span>全部</span> </li>
                <li :class="{ active: activeIndex2 == 1 && firstCategory === largeSceneCate.cateId }" @click="() => { searchContent = ''; activeIndex2 = 1; changeFirstCategory(largeSceneCate) }"> <span>倾斜摄影</span> </li>
                <li v-for="item in firstCategories" :class="{ active: firstCategory === item.cateId && activeIndex2 == 1 }" :key="item.cateId" @click="() => { searchContent = ''; changeFirstCategory(item); activeIndex2 = 1; }">
                    <span>{{item.cateName}}</span> 
                </li>
            </ul>
            <div @click="refresh" class="refresh"> <i class="iconfont icongengxin"></i> </div>
            <div class="mine" v-show="activeIndex2 == 1">
                <div class="search">
                    <el-input suffix-icon="el-icon-search" placeholder="输入关键词查找模型" v-model="searchContent" @change="modelList = []; pageNo = 1; loadModels()" />
                </div>
                <ul class="category_3">
                    <li @click="changeSecondCategory('')" :class="{ active: secondCategory == '' }">全部</li>
                    <li v-show="firstCategory !== ''" v-for="item in secondCategories" :key="item.cateId" @click="changeSecondCategory(item.cateId)" :class="{ active: secondCategory == item.cateId }">{{item.cateName}}</li>
                </ul>
                <ul class="list" v-infinite-scroll="loadModels" :infinite-scroll-disabled="isLoading || noData" infinite-scroll-immediate="false">
                    <li v-for="(item, index) in modelList" :class="{ active: item.modelId == selectedModelId }" :key="index" @mousedown="selectedModelId = item.modelId; selectModelHandler(item)">
                        <img :src="item.preview | parseUrl" :alt="item.modelName" :title="item.modelName" />
                    </li>
                    <li class="empty" v-if="modelList.length == 0">
                        <img src="@/assets/img/none.png" />
                        <p>未找到相关模型</p>
                    </li>
                </ul>
            </div>
            <div class="mine" v-show="activeIndex2 == 0">
                <div class="search">
                    <el-input suffix-icon="el-icon-search" placeholder="输入关键词查找模型" v-model="searchContent" @change="myModelList = []; pageNo = 1; loadMyModels()" />
                </div>
                <ul class="list" v-infinite-scroll="loadMyModels" :infinite-scroll-disabled="isLoading || noData" infinite-scroll-immediate="false">
                    <li v-for="(item, index) in myModelList" :key="index" @mousedown="selectedModelId = item.modelId; selectModelHandler(item)" :class="{ active: item.modelId == selectedModelId }">
                        <a :href="payUrl" target="_blank" class="pay" @mousedown.stop="() => null" v-if="item.payed === false">
                            <i class="iconfont iconzhifu"></i> <span>去支付</span>
                        </a>
                        <img :src="item.preview" :alt="item.modelName" :title="item.modelName" v-if="item.preview" />
                        <img src="@/assets/img/default.png" :alt="item.modelName" :title="item.modelName" v-else />
                    </li>
                    <li class="empty" v-if="myModelList.length == 0">
                        <img src="@/assets/img/none.png" />
                        <p>未找到相关模型</p>
                    </li>
                </ul>
                <el-button @click="myModelData = []; Object.assign(queryParam, $options.data().queryParam); selectedList = []; loadModelList();" round class="btn" type="primary"> 添加素材 </el-button>
            </div>
        </div>
        <!-- 模型库 -->
        <div class="mask" @click.stop="() => null" v-if="queryParam.show">
            <div class="store">
                <h4><span>添加素材-我的模型</span> <i class="iconfont iconguanbi" @click.stop="queryParam.show = false; myModelData = []; queryParam.pageNo = 1; selectedList = []; "></i></h4>
                <nav>
                    <div style="width: 40%;"> 
                        <span>日期</span>     
                        <el-date-picker
                            v-model="queryParam.daterange"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期" 
                            @change="() => { myModelData = []; queryParam.pageNo = 1; loadModelList(); }"
                        >
                        </el-date-picker>
                    </div>
                    <div style="width: 30%;">
                        <span>模型类别</span>
                        <el-select v-model="queryParam.modelType" placeholder="请选择" @change="() => { myModelData = []; queryParam.pageNo = 1; loadModelList(); }">
                            <el-option
                                v-for="item in [{ label: '单模型', value: 0 },{ label: '倾斜摄影模型', value: 1 }]"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div style="width: 30%;">
                        <span>模型名称</span>
                        <el-input v-model="queryParam.modelName" @change="() => { myModelData = []; queryParam.pageNo = 1; loadModelList(); }" placeholder="请输入关键词" suffix-icon="el-icon-search"></el-input>
                    </div>
                </nav>
                <ul v-infinite-scroll="loadModelList" :infinite-scroll-disabled="isLoading || queryParam.noData" infinite-scroll-immediate="false" v-loading="isLoading">
                    <li v-for="item in myModelData" :key="item.id" @click.stop="checkModel(item)">
                        <img :src="item.preview" :alt="item.modelName" :title="item.modelName" v-if="item.preview" />
                        <img src="@/assets/img/default.png" :alt="item.modelName" :title="item.modelName" v-else />
                        <span v-show="item.selected"> <i class="iconfont iconcheck"></i> </span>
                        <p>{{ item.modelType == 0 ? '单模型' : '倾斜摄影模型' }}</p>
                    </li>
                </ul>
                <div class="btn">
                    <p>已选模型 : {{selectedList.length}} 个</p>
                    <el-button round type="primary" @click.stop="addModelMaterial">添加</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BusEvent from '@/busEvent'
import { ResponseCode } from '@/utils/axios'
import Cookie from "js-cookie"
import uuid from 'uuidjs'
import Util from '@/utils/util'

var baseUrl = process.env.MODE == 'pro' ? 'https://www.laozicloud.com' : 'https://www.laozicloud.net'
var pointerMaterial = new AMRT.MeshPhongMaterial({ 
    color: 0x1458EA
})
var levelLoader = new AMRT.LevelLoader(), pointer
var indicator = Util.createIndicator()

export default {
    
    data(){
        return {
            activeIndex2: 0,
            searchContent: '',
            modelList: [],      //当前分类下系统模型列表
            myModelList: [],    //我的模型列表
            pageNo: 1,
            pageSize: 30,
            firstCategories: [],    //一级分类
            firstCategory: false,      //当前一级分类
            secondCategories: [],   //二级分类
            secondCategory: '',    //当前二级分类
            isLoading: true,
            noData: false,
            selectedModelId: '',
            payUrl: baseUrl + '/workbench/serviceResult',
            myModelData: [],
            queryParam: {
                show: false,
                daterange: '',
                modelType: 0,
                modelName: '',
                pageNo: 1,
                pageSize: 50,
                noData: false
            },
            selectedList: [],
            largeSceneCate: {},
        }
    },

    computed: {

        viewer(){
            return window.viewer
        },

        container(){
            return window.viewer.container
        },

        tool(){
            return this.$parent.$parent.$refs.tool
        }

    },

    filters: {
        parseUrl: function( url ){
            if(url.startsWith('https')){
                return url
            }
            return 'https://laozi-autopublic-east.obs.cn-east-2.myhuaweicloud.com/' + url
        }
    },

    mounted(){
        this.init()
        this.loginEvent = () => {
            setTimeout(() => {
                this.init()
            }, 2000)
        }
        this.$bus.$on( BusEvent.LoginSuccess, this.loginEvent )
    },

    beforeDestroy(){
        this.$bus.$off( BusEvent.LoginSuccess, this.loginEvent )
    },

    methods: {

        init(){
            //单模型分类列表
            this.axios.post('/api-transaction/laozi/v3/transaction/unauth/model/labelCate', { cateType: 0 }).then(res => {
                this.firstCategories = res.datas || []
                this.changeFirstCategory( res.datas[0] )
            })

            //倾斜摄影分类列表
            this.axios.post('/api-transaction/laozi/v3/transaction/unauth/model/labelCate', { cateType: 1 }).then(res => {
                this.largeSceneCate = res.datas[0]
            })

            if( Cookie.get('loginId') ){
                this.pageNo = 1
                this.myModelList = []
                this.noData = false
                this.loadMyModels()
            }
        },


        /**
         * 单击选中模型
         */
        selectModelHandler( model ){
            if( model.modelId ){
                this.isLoading = true
                this.axios.post( '/api-transaction/laozi/v3/transaction/unauth/model/getModelPaths', {
                    modelId: model.modelId
                }).then(res => {
                    if( res.resp_code == ResponseCode.SUCCESS ){
                        if( res.datas.levelUrl ){
                            console.log(this.viewer.modelGroup.children, res.datas.levelUrl);
                            let exist = this.viewer.modelGroup.children.find(item => item.path == res.datas.levelUrl + '/' )
                            if( exist ){
                                return this.$message.warning('该场景模型已经添加，不能重复添加')
                            }
                            this.toSetModel({
                                levelUrl: res.datas.levelUrl + '/',
                                coordinate: res.datas.coordinate,
                                name: model.modelName,
                                id: model.modelId
                            })
                        }else{
                            var paths = {}, mTask = [], matTask = []
                            var obsParam = {
                                m: [],
                                mat: [],
                                scene: '',
                                sky: {}
                            }
                            var param = {
                                paths,
                                obsParam,
                                name: model.modelName,
                                id: model.modelId,
                            }
                            paths.sky = res.datas.paths.sky
                            obsParam.sky = paths.sky
                            let { bucket, key } = this.$util.rebuildObsPath(res.datas.paths.scene)
                            obsParam.scene = { bucket, key }
                            this.$util.getObsFile(bucket, key).then(url => {
                                paths.scene = url
                                if( paths.m !== undefined && paths.mat !== undefined ){
                                    this.toSetModel(param)
                                }
                            })
                            res.datas.paths.m.map(item => {
                                let { bucket, key } = this.$util.rebuildObsPath(item)
                                obsParam.m.push({ bucket, key })
                                mTask.push(this.$util.getObsFile(bucket, key))
                            })
                            res.datas.paths.mat.map(item => {
                                let { bucket, key } = this.$util.rebuildObsPath(item)
                                obsParam.mat.push({ bucket, key })
                                matTask.push(this.$util.getObsFile(bucket, key))
                            })
                            Promise.all(mTask).then(res => {
                                paths.m = res
                                if( paths.mat !== undefined && paths.scene !== undefined ){
                                    this.toSetModel(param)
                                }
                            })
                            Promise.all(matTask).then(res => {
                                paths.mat = res
                                if( paths.m !== undefined && paths.scene !== undefined ){
                                    this.toSetModel(param)
                                }
                            })

                        }
                    }else{
                        console.warn( res.resp_msg )
                    }

                    // this.$util.getObsFile('laozi-lightweight-test/release/AMRT', 'e0c559fc-c5d8-4c24-9818-2e0647ddc4e9.json.gz', path => {
                    //     console.log(path);
                    // })
                }).finally(() => {
                    this.isLoading = false
                })


                // this.axios.post( '/api-transaction/laozi/v3/transaction/unauth/model/modelPreview', {
                //     modelId: model.modelId,
                //     userId: Cookie.get('loginId')
                // }).then( res => {
                //     if( res.resp_code == ResponseCode.SUCCESS ){
                //         if( res.datas.levelUrl ){
                //             let exist = this.viewer.modelGroup.children.find(item => item.path == res.datas.levelUrl + '/' )
                //             if( exist ){
                //                 return this.$message.warning('该场景模型已经添加，不能重复添加')
                //             }
                //             this.toSetModel({
                //                 levelUrl: res.datas.levelUrl + '/',
                //                 coordinate: res.datas.coordinate,
                //                 name: model.modelName,
                //                 id: model.modelId
                //             })
                //         }else{
                //             this.toSetModel({
                //                 paths: res.datas.paths,
                //                 name: model.modelName,
                //                 id: model.modelId
                //             })
                //         }
                //     }else{
                //         console.warn( res.resp_msg )
                //     }
                // }).finally(() => {
                //     this.isLoading = false
                // })
            }else{
                this.$message.warning('模型ID丢失')
            }
        },

        /**
         * 初始化模型放置
         */
        toSetModel( model ){
            this.$bus.$emit( BusEvent.ToolChange )
            //关闭测量
            if( this.viewer.mapMeasure  ){
                this.viewer.mapMeasure.enable = false
            }
            if( this.viewer.root.getObjectByName('pointer') ){
                this.viewer.root.remove( pointer )
                this.container.removeEventListener( 'mousemove', this.mousemoveHandler )
                this.container.removeEventListener( 'mousedown', this.dropHandler )
                this.viewer.map.camera.changed.removeEventListener( this.pointerMoveHandler )
            }
            //倾斜摄影计算边界大小，生成对应大小的Box
            if( model.levelUrl ){
                levelLoader.load( model.levelUrl + 'level.json.gz', res => {
                    var levels = res.levels
                    levels = levels.filter( item => item.acfl == 0 )
                    var boundingBox = this.$util.getBoundingBox( levels )
                    pointer = new AMRT.Mesh(
                        new AMRT.BoxBufferGeometry( boundingBox.max.x - boundingBox.min.x, (boundingBox.max.y - boundingBox.min.y) / 2, boundingBox.max.z - boundingBox.min.z, 1, 1, 1 ), 
                        pointerMaterial
                    )
                    pointer.name = 'pointer'
                    pointer.type = 'box'
                    this.viewer.root.add( pointer )
                }, null, null, true )
            }else{
                pointer = indicator
                this.viewer.root.add( pointer )
            }
            //倾斜摄影有经纬度情况下直接放置
            if( model.coordinate ){
                const coordinate = model.coordinate.split(','), loading = this.$loading()
                this.viewer.loadLargeScene( model.levelUrl, {
                    position: this.viewer.gisManager.langLatToVector3( coordinate[1], coordinate[0], 15 ),     //模型位置
                    modelName: model.name,  //模型名称
                    mid: uuid.genV4().toString(),   //唯一ID
                    fitCamera: true,
                    onLoad: m => {
                        loading.close()
                        this.selectedModelId = ''
                        this.tool.toggleSelector()
                        m.loader.updateLevels()
                        this.viewer.selectedObject = [ m ]
                        this.viewer.gisManager.cameraChangeHandler()
                        this.$bus.$emit( BusEvent.SceneChange )
                        m.loader.loadEnd = () => {
                            m.loader.loader = null
                            this.$bus.$emit( BusEvent.SelectedChange )
                        }
                    }
                })
                setTimeout(() => {
                    loading.close()
                }, 20000)
            }else{
                this.$message.success( '请在地图中选择放置模型位置' )
                this.selected = model
                this.viewer.gisManager.cameraChangeHandler()
                this.dropHandler = this.dropModel.bind(this)
                this.container.addEventListener( 'mousedown', this.dropHandler )
                this.container.addEventListener( 'mousemove', this.mousemoveHandler )
                this.pointerMoveHandler = this.viewChangeHandler.bind(this)
                this.viewer.map.camera.changed.addEventListener( this.pointerMoveHandler )
                this.pointerMoveHandler()
            }
        },

        /**
         * 监听视角变化  动态显示/隐藏光标
         */
        viewChangeHandler(){
            if( !pointer ) return
            let v = new AMRT.Vector3().copy( pointer.position )
            let tempV = new AMRT.Vector3().copy( v ).applyMatrix4( this.viewer.camera.matrixWorldInverse ).applyMatrix4( this.viewer.camera.projectionMatrix )
            if ( (Math.abs(tempV.x) > 1) || (Math.abs(tempV.y) > 1) || (Math.abs(tempV.z) > 1) ) {
                this.container.style.cursor = 'default'
                this.hideCursor = false
            } else {
                this.container.style.cursor = 'none'
                this.hideCursor = true
            }
        },

        mousemoveHandler( e ){                                                                                                                                    
            if( !pointer ) return
            const cartesian = this.viewer.pick( e )
            if( !cartesian ) return
            const v = this.viewer.cartesian3ToVector3( cartesian )
            pointer.position.copy( v )
            this.viewer.changeRotationToUp( pointer )
            if( pointer.type != 'box' ){
                const distance = v.distanceTo( this.viewer.cartesian3ToVector3( this.viewer.camera.position ) )
                pointer.scale.set( distance / 1000, distance / 1000, distance / 1000 )
            }
        },

        /**
         * 放置模型
         */
        dropModel( e ){
            this.viewer.map.camera.changed.removeEventListener( this.pointerMoveHandler )
            this.container.style.cursor = 'default'  //显示光标
            this.viewer.root.remove( pointer )
            this.container.removeEventListener( 'mousemove', this.mousemoveHandler )
            this.container.removeEventListener( 'mousedown', this.dropHandler )
            this.selectedModelId = ''
            if( e.button == 2 ) return  //右键取消放置
            if( this.selected.levelUrl ){
                var loading = this.$loading()
                this.tool.toggleSelector()
                this.viewer.loadLargeScene( this.selected.levelUrl, {
                    position: this.$util.setVector3ViaHeight( pointer.position, 15 ),     //模型位置
                    modelName: this.selected.name,  //模型名称
                    mid: uuid.genV4().toString(),   //唯一ID
                    fitCamera: true,
                    onLoad: m => {
                        loading.close()
                        this.viewer.controls.fit( m )
                        this.tool.toggleSelector()
                        this.viewer.selectedObject = [ m ]
                        this.$bus.$emit( BusEvent.SceneChange )
                        m.loader.loadEnd = () => {
                            m.loader.loadEnd = null
                            this.$bus.$emit( BusEvent.SelectedChange )
                        }
                    }
                })
                setTimeout(() => {
                    loading.close()
                }, 20000)
                pointer = null
            }else{
                let loading = this.$loading()
                this.viewer.loadModel(this.selected.paths, {
                    position: pointer.position,     //模型位置
                    modelName: this.selected.name,  //模型名称
                    sourceId: this.selected.id,     //模型来源
                    obsParam: this.selected.obsParam,   //华为云参数
                    mid: uuid.genV4().toString(),   //唯一ID
                    onLoad: m => {
                        pointer = null
                        loading.close()
                        //限制单模型大小
                        if( m.boundBox ){
                            let size = m.boundBox.getSize()
                            let max = Math.max( size.x, size.y, size.z ), min = Math.min( size.x, size.y, size.z )
                            if( max < 20 ){
                                m.scale.set( 20 / max, 20 / max, 20 / max )
                            }
                            if( min > 1000 ){
                                m.scale.set( 1000 / min, 1000 / min, 1000 / min )
                            }
                        }
                        this.viewer.controls.fit( m )
                        this.tool.toggleSelector()
                        this.viewer.selectedObject = [ m ]
                        this.$bus.$emit( BusEvent.SceneChange )
                        this.$bus.$emit( BusEvent.SelectedChange )
                    }
                })
            }
        },

        /**
         * 修改物品库一级分类
         */
        changeFirstCategory( item ){
            this.firstCategory = item.cateId || ''
            this.secondCategory = ''
            this.secondCategories = item.labelObjects || []
            this.changeSecondCategory()
        },

        /**
         * 修改物品库二级分类
         */
        changeSecondCategory( cateId ){
            if( cateId !== undefined ) this.secondCategory = cateId
            this.pageNo = 1
            this.modelList = []
            this.noData = false
            this.loadModels()
        },

        /**
         * 加载当前分类下系统模型
         */
        loadModels() {
            this.isLoading = true
            if( this.searchContent ){
                this.firstCategory = ''
                this.secondCategory = ''
            }
            this.axios.post('/api-application/fullSceneEditor/defaultModelList', {
                labelCateId: this.firstCategory,
                labelObjectId: this.secondCategory,
                modelName: this.searchContent,
                pageNo: this.pageNo,
                pageSize: this.pageSize
            }).then(res => {
                this.isLoading = false
                if( res.resp_code == 60000 && res.datas && Array.isArray(res.datas.results) ){
                    if( res.datas.results.length > 0 ){
                        this.modelList = this.modelList.concat(res.datas.results)
                        res.datas.results.length > 0 && this.pageNo ++
                    }else if( this.pageNo > 1 ){
                        this.noData = true
                        this.$notify.info({
                            title: '提示',
                            message: '没有数据了',
                            duration: 1500,
                            position: 'bottom-right'
                        })
                    }
                }
            })
        },

        /**
         * 加载我的模型
         */
        loadMyModels(){
            this.isLoading = true
            this.axios.post('/api-application/fullSceneEditor/myModelMaterialList', { 
                userId: Cookie.get('loginId'),
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                modelName: this.searchContent
            }).then(res => {
                this.isLoading = false
                if( res.resp_code == 60000 && res.datas && Array.isArray(res.datas.results) ){
                    if( res.datas.results.length > 0 ){
                        this.myModelList.push(...res.datas.results)
                        res.datas.results.length > 0 && this.pageNo ++
                    }else if( this.pageNo > 2 ){
                        this.noData = true
                        this.$notify.info({
                            title: '提示',
                            message: '没有数据了',
                            duration: 1500,
                            position: 'bottom-right'
                        })
                    }
                }
            })
        },

        /**
         *  刷新数据
         */
        refresh(){
            this.init()
            this.activeIndex2 = 0
        },

        
        /**
         * 查看全部模型
         */
        loadModelList(){
            this.isLoading = true
            this.axios.post('/api-application/fullSceneEditor/myModelList', {
                startTime: this.queryParam.daterange ? this.$util.parseDate( this.queryParam.daterange[0] ) : '',
                endTime: this.queryParam.daterange ? this.$util.parseDate( this.queryParam.daterange[1] ) : '',
                modelType: this.queryParam.modelType,
                pageNo: this.queryParam.pageNo,
                pageSize: this.queryParam.pageSize,
                modelName: this.queryParam.modelName
            }).then( res => {
                this.isLoading = false
                if( Array.isArray( res.datas.results ) ){
                    res.datas.results.map( item => {
                        if( this.selectedList.includes( item.modelId ) ){
                            item.selected = true
                        }
                    })
                    this.myModelData = this.myModelData.concat( res.datas.results )
                }   
                this.queryParam.show = true
                if( res.datas.results && res.datas.results.length == this.queryParam.pageSize ){
                    this.queryParam.pageNo += 1
                    this.queryParam.noData = false
                }else{
                    this.queryParam.noData = true
                }
            })
        },

        checkModel( model ){
            model.selected = !model.selected
            if( model.selected ){
                this.selectedList.push( model.modelId )
            }else{
                this.selectedList.splice( this.selectedList.indexOf( model.modelId ), 1 )
            }
        },

        addModelMaterial(){
            if( !Array.isArray( this.selectedList ) || this.selectedList.length == 0 ){
                this.$message.warning('请选中模型')
                return
            }
            this.axios.post('/api-application/fullSceneEditor/addModelMaterial', {
                modelIds: this.selectedList.join(',')
            }).then( res => {
                this.$message.success( res.resp_msg )
                if( res.resp_code == 60000 ){
                    this.myModelList = []
                    this.queryParam.pageNo = 1
                    this.pageNo = 1
                    this.loadMyModels()
                    this.queryParam.show = false
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.menu_0{
    width: 100%; height: 100%; background-color: #F2F4F6; display: flex;
    .menu_left{
        width: 50px; height: calc(100% - 80px); padding-bottom: 80px; display: flex; flex-direction: column; background-color: #fff; align-items: center; position: relative; overflow-y: scroll; margin-top: 1px;
        li{
            width: 100%; padding: 20px 0; display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer; position: relative;
            span{ display: block; width: 70%; font-size: 14px; text-align: center; color: #5D6B7F; }
            .iconfont{ font-size: 20px; color: #5D6B7F;}
            &:hover{
                span, .iconfont{color: #1458EA;}
            }
            &::after{
                content: ''; display: block; position: absolute; width: 28px; bottom: -1px; left: 10px; height: 1px; background-color: rgba(0,0,0,0.35); opacity: 0.5;
            }
            &:nth-last-child(1)::after{
                opacity: 0;
            }
        }

        .active{
            background-color: #F2F4F6;  border-color: #1458EA;
            span, .iconfont{color: #1458EA;}
            &::after{
                content: ''; display: block; position: absolute; width: 30px; bottom: 0; left: 10px; height: 1px; background-color: #1458EA; opacity: 0.5;
            }
        }
        scrollbar-width: none; /* Firefox */
        
    }
    .refresh{
        width: 50px; text-align: center; padding: 20px 0 35px 0; cursor: pointer; position: absolute; bottom: 0; background-color: #fff; width: 50px;
        .iconfont{ font-size: 20px; color: #5D6B7F;}
    }
    .menu_left::-webkit-scrollbar-track, .menu_left::-webkit-scrollbar{ width: 0 !important; display: none !important; } /* Chrome Safari */
    .mine{
        width: calc(100% - 50px); position: relative; top: 1px;
        .search{
            width: 100%; background-color: #fff; height: 54px; display: flex; justify-content: center; align-items: center; border-bottom: 1px solid rgba(0,0,0,0.1);
            /deep/ .el-input{
                width: 90%; height: 34px;
                .el-input__inner{border: none; height: 30px; background-color: #F2F4F6;}
                .el-input__suffix{top: -5px; color: #000;}
            }
        }
        .btn{
            position: absolute; bottom: 10px; width: 140px; left: calc(50% - 70px); margin-bottom: 20px;
        }
        /deep/ .el-button{ background-color: #1458EA; border: none; }
        .list{
            width: 314px; height: calc( 100% - 158px ); margin: 0 auto; overflow-y: scroll; scrollbar-width: thin;
            li{ 
                width: 30%; height: 92px; float: left; margin: 5px 0; display: flex; justify-content: center; cursor: pointer; position: relative; background: #FFF; margin-right: 4px; border: 3px solid transparent; border-radius: 9px;
                img{ width: 100%; height: 92px; -webkit-user-drag: none; border-radius: 5px;}
                .pay{
                    display: block; width: 92px; height: 92px; background-color:#182C49; opacity: 0.8; position: absolute; top: 0; left: 5px; border-radius: 5px; display: flex; flex-direction: column; justify-content: center; align-items: center; color: #FFF;
                    span{margin-top: 10px;}
                    .iconfont{font-size: 20px;}
                }
            }
            .empty{ 
                background: transparent;  margin: 20px auto; display: flex; flex-direction: column; align-items: center; width: 92%;
                img{ width: 92px; opacity: 0.5; margin-top: 150px; }
                p{text-align: center; margin-top: 10px; color: #5D6B7F;}
            }
            .active{ border: 3px solid #1458EA; }
        }
        .category_2{
            width: 100%; display: flex; justify-content: center;background-color: #fff; padding: 10px 0;
            /deep/ .el-select{ width: 90%; }
        }
        .category_3{
            width: 314px; margin: 0 auto 10px auto; display: flex; flex-wrap: wrap; max-height: 70px; overflow-y: scroll; scrollbar-width: none; /* Firefox */
            li{
                padding: 10px; color: #5D6B7F; font-size: 12px; cursor: pointer; flex-wrap: wrap;
                &:hover{color: #1458EA;}
            }
            .active{color: #1458EA;}
            &::-webkit-scrollbar {
                display: none; /* Chrome Safari */
            }
        }
    }
}
.mask{
    position: fixed; z-index: 999; background-color: rgba(0,0,0,0.5); display: flex; width: 100vw; height: 100vh; justify-content: center; align-items: center; top: 0; left: 0;
}
.store{
    width: 900px; height: 690px; padding: 20px; background-color: #fff; border-radius: 10px;
    h4{ 
        text-align: center; position: relative;  padding: 0 0 20px 0;
        border-bottom: 1px solid rgba(7, 44, 110, 0.1);
        .iconfont{position: absolute; right: 0; cursor: pointer;} 
    }
    nav{
        margin-top: 10px; display: flex; justify-content: space-around;
        >div{
             margin: 0 1.5%; width: 30%; display: flex; height: 60px; align-items: center;
            >span{
                color: #182C49; opacity: 0.7; margin-right: 15px; font-size: 14px;
            }
            /deep/ .el-date-editor{ width: calc(100% - 50px); background-color: #F6F7F8; border: none; input{ background-color: #F6F7F8; border: none;} }
            /deep/ .el-select{ width: calc(100% - 80px); input{ background-color: #F6F7F8; border: none;} }
        }
        >div:nth-child(3){
            /deep/ .el-input{ width: calc(100% - 80px); input{ background-color: #F6F7F8; border: none;} }
        }
    }
    ul{
        height: 460px; width: calc(100% - 55px); padding: 10px; margin: 0 auto; display: flex; flex-wrap: wrap; background-color: #E9ECEE; overflow-y: scroll; scrollbar-width: thin; border-radius: 10px;
        li{ 
            width: 155px; height: 155px; margin: 6px; cursor: pointer; position: relative; border-radius: 8px; overflow: hidden;
            img{ width: 100%; height: 100%;  background-color: #fff; }
            span{ 
                display: block; border-width: 15px; border-style: solid; border-color: transparent #1458EA #1458EA transparent; width: 0; height: 0; position: absolute; bottom: 0; right: 0; 
                .iconfont{ position: absolute; right: -17px; bottom: -18px; color: #FFF; font-size: 20px; }
            }
            p{
                position: absolute; left: 0; top: 0; display: inline-block; padding: 6px 10px; background-color: rgba(24, 44, 73, 0.7); color: #FFF; font-size: 12px; border-radius: 8px 0 8px 0;
            }
        }
        li:hover{ box-shadow: 0 0 15px rgba(0,0,0,0.35); }
    }
    .btn{
        display: flex; flex-direction: column; align-items: center; justify-content: center; height: 80px;
        p{ font-size: 14px; margin: 10px 0; }
        /deep/ .el-button--primary{
            background-color: #1458EA; border-color: #1458EA; height: 35px; line-height: 1px; width: 120px;
        }
    }
}
</style>
<style lang="scss">
.el-select-dropdown__item.selected {
    color: #1458ea !important;
    font-weight: 500 !important;
}
.el-select .el-input.is-focus .el-input__inner {
    border-color: #1458ea !important;
}
.el-date-table td.end-date span, .el-date-table td.start-date span{
    background-color: #1458ea !important;
}
.el-date-table td.today span{
    color: #1458ea !important;
}
</style>